package br.com.vvrefeicoes.portal.feature.auth.login

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material3.Checkbox
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.input.key.Key
import androidx.compose.ui.input.key.KeyEventType
import androidx.compose.ui.input.key.key
import androidx.compose.ui.input.key.onPreviewKeyEvent
import androidx.compose.ui.input.key.type
import androidx.compose.ui.text.input.PasswordVisualTransformation
import androidx.compose.ui.text.input.VisualTransformation
import br.com.vvrefeicoes.portal.core.ui.components.AppButton
import br.com.vvrefeicoes.portal.core.ui.components.AppTextField
import br.com.vvrefeicoes.portal.core.ui.components.PortalButtonVariant
import br.com.vvrefeicoes.portal.core.ui.theme.AppSpacing
import com.composables.icons.lucide.Eye
import com.composables.icons.lucide.EyeOff
import com.composables.icons.lucide.Lock
import com.composables.icons.lucide.Lucide
import com.composables.icons.lucide.User
import org.jetbrains.compose.resources.stringResource
import portalvv.shared.generated.resources.Res
import portalvv.shared.generated.resources.auth_access_app
import portalvv.shared.generated.resources.auth_access_app_helper
import portalvv.shared.generated.resources.auth_email
import portalvv.shared.generated.resources.auth_forgot_password
import portalvv.shared.generated.resources.auth_login
import portalvv.shared.generated.resources.auth_password
import portalvv.shared.generated.resources.auth_password_omit
import portalvv.shared.generated.resources.auth_password_show
import portalvv.shared.generated.resources.auth_remember_me

@Composable
fun LoginForm(
    controller: LoginController,
    modifier: Modifier = Modifier,
) {
    var passwordVisible by remember { mutableStateOf(false) }

    Column(
        modifier =
            modifier.onPreviewKeyEvent { event ->
                if (event.type == KeyEventType.KeyDown && (event.key == Key.Enter || event.key == Key.NumPadEnter)) {
                    controller.submit()
                    true
                } else {
                    false
                }
            },
        verticalArrangement = Arrangement.spacedBy(AppSpacing.space16),
    ) {
        Text(
            text = stringResource(Res.string.auth_access_app),
            style = MaterialTheme.typography.headlineSmall,
        )
        Text(
            text = stringResource(Res.string.auth_access_app_helper),
        )
        AppTextField(
            value = controller.login,
            onValueChange = { controller.login = it },
            label = stringResource(Res.string.auth_email),
            singleLine = true,
            modifier = Modifier.fillMaxWidth(),
            leadingIcon = { Icon(Lucide.User, contentDescription = null) },
        )

        AppTextField(
            value = controller.password,
            onValueChange = { controller.password = it },
            label = stringResource(Res.string.auth_password),
            singleLine = true,
            visualTransformation =
                if (passwordVisible) VisualTransformation.None else PasswordVisualTransformation(),
            leadingIcon = { Icon(Lucide.Lock, contentDescription = null) },
            trailingIcon = {
                IconButton(onClick = { passwordVisible = !passwordVisible }) {
                    Icon(
                        imageVector = if (passwordVisible) Lucide.Eye else Lucide.EyeOff,
                        contentDescription = if (passwordVisible) stringResource(Res.string.auth_password_omit) else stringResource(Res.string.auth_password_show),
                    )
                }
            },
            modifier = Modifier.fillMaxWidth(),
        )

        Row(verticalAlignment = androidx.compose.ui.Alignment.CenterVertically) {
            Checkbox(
                checked = controller.rememberMe,
                onCheckedChange = { controller.rememberMe = it },
            )
            Text(text = stringResource(Res.string.auth_remember_me))
        }

        controller.errorResource?.let { resource ->
            Text(
                text = stringResource(resource),
                style = MaterialTheme.typography.bodySmall,
                color = MaterialTheme.colorScheme.error,
            )
        }

        AppButton(
            onClick = controller::submit,
            enabled = !controller.loading,
            modifier = Modifier.fillMaxWidth(),
            text = stringResource(Res.string.auth_login),
        )
        AppButton(
            onClick = controller::forgotPassword,
            modifier = Modifier.fillMaxWidth(),
            variant = PortalButtonVariant.Outlined,
            text = stringResource(Res.string.auth_forgot_password),
        )
    }
}
